import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import './KeywordTags.scss';

interface KeywordTagsProps {
  keywordsString: string[] | undefined;
  keywordsMap: Map<string, string>;
  containerWidth?: number;
  minVisibleKeywords?: number;
  uniqueId: string;
}

const KeywordTags: React.FC<KeywordTagsProps> = ({
  keywordsString,
  keywordsMap,
  containerWidth = 360,
  minVisibleKeywords = 5,
  uniqueId,
}) => {
  const parseKeywords = (input: string[] | undefined): string[] => {
    if (!input) return [];
    
    return input
      .map(k => k.trim().replace(/["'\[\]\(\)]/g, ''))
      .filter(Boolean);
  };

  const keywords = parseKeywords(keywordsString);

  if (keywords.length === 0) return null;

  const estimatedKeywordWidth = 65;
  const calculatedMaxKeywords = Math.floor((containerWidth - 50) / estimatedKeywordWidth);
  const maxVisibleKeywords = Math.max(minVisibleKeywords, Math.max(0, calculatedMaxKeywords));

  const visibleKeywords = keywords.slice(0, Math.min(maxVisibleKeywords, keywords.length));
  const hiddenKeywords = keywords.slice(visibleKeywords.length);
  const tooltipId = `keywords-tooltip-${uniqueId}`;

  return (
    <div className="keyword-tags">
      {visibleKeywords.map((keyword, index) => (
        <span key={`kw-${index}`} className="tag tag--second tag--short">
          {keywordsMap.get(keyword) ?? keyword}
        </span>
      ))}
      {hiddenKeywords.length > 0 && (
        <>
          <span
            id={tooltipId}
            className="tag tag--second tag--short tag--overflow"
            data-pr-tooltip={hiddenKeywords.map(kw => keywordsMap.get(kw) ?? kw).join(', ')}
          >
            +{hiddenKeywords.length}
          </span>
          <Tooltip target={`#${tooltipId}`} position="top" />
        </>
      )}
    </div>
  );
};

export default KeywordTags;

